export const actualPage: any = 0;
export const rowsPerPage: any = 25;
export const rowsPerPageOptions: any = [5, 10, 20, 50];
